import React from 'react';

function StatusView({ status }) {
  return (
    <span
      style={{ color: '#ffffff', backgroundColor: status ? '#3b5aa9' : '#FF2437', padding: 10 }}
    >
      {status ? 'Opened' : 'Closed'}{' '}
    </span>
  );
}

export default StatusView;
